import { render, staticRenderFns } from "./outcomeStockMovementTransferBox.vue?vue&type=template&id=68befee0&"
import script from "./outcomeStockMovementTransferBox.vue?vue&type=script&lang=ts&"
export * from "./outcomeStockMovementTransferBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports